<template>
  <div>
    <h1>LOGIN</h1>

    <form @submit="login">
      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <input
          type="email"
          v-model="email"
          class="form-control"
          placeholder="email"
          id="email"
          aria-describedby="emailHelp"
        />
        <div id="emailHelp" class="form-text">fill in email address...</div>
      </div>
      <div class="mb-3">
        <label for="password" class="form-label">Password</label>
        <input
          type="password"
          v-model="password"
          placeholder="password"
          class="form-control"
          id="password"
          autocomplete="on"
        />
        <div id="passwordHelp" class="form-text">fill in password...</div>
      </div>
      <button type="submit" class="btn btn-primary">Submit</button>
    </form>
  </div>
</template>

<script>
import { store } from "../store";
import axios from "axios";
export default {
  data: () => {
    return {
      email: "super-administrator@gmail.com",
      password: "",
    };
  },
  methods: {
    async login(e) {
      e.preventDefault();
      const instance = axios.create({
        baseURL: "https://vdatame.dealersonline.ae",
        headers: { "Content-Type": "application/json" },
      });

      try {
        const {
          data: {
            data: { user, token, refresh },
          },
        } = await instance.post("/api/auth/login", {
          email: this.email,
          password: this.password,
        });
        let dispatchActions = async () => {
          await store.dispatch("setUser", user);
          await store.dispatch("setToken", token);
          await store.dispatch("setRefreshToken", refresh);
        };
        dispatchActions().then(() => (window.location.href = "/"));
      } catch (e) {
        this.$swal(e.response.data.errors[0].message);
      }
    },
  },
};
</script>
